module.exports = __webpack_public_path__ + "static/media/Cloudy_Bored.7202721c.gif";